module.exports = __webpack_public_path__ + "img/pr-4.ba1492f0.png";